module.exports = __webpack_public_path__ + "static/media/okkji-big-favicon.3b90b65d.png";